import { InputNumber } from "antd";
import React from "react";
import { InputWrapper, SplitInputWrapperProps } from "../../functions";
import { NumberInputBoxProps } from "./interface";
import { toLowerCaseWithUnderscore } from "../../../../utils/commonFunctions";
import { validations } from "../../../../config/validations/validations";
import { numericField } from "../../../../config/Global";

const NumberInputBox: React.FC<NumberInputBoxProps> = props => {
  const { formProps, inputProps } = SplitInputWrapperProps(props);


  return (
    <InputWrapper
      onKeyDown={numericField}
      rules={
        formProps.required
          ? [
              validations.required.text(),
              {
                validator: (rule, value) =>
                  validations.validators.validateNumber(
                    rule,
                    value,
                    inputProps.minValue,
                    inputProps.maxValue
                  ),
              },
            ]
          : []
      }
      label={formProps.label && `${formProps.label}`?.toTitleCase()}
      name={formProps.label && toLowerCaseWithUnderscore(formProps.label)}
      {...formProps}
    >
      <InputNumber
        placeholder={formProps?.label}
        // formatter={handleFormatter}
        // parser={handleParser}
        {...inputProps}
      />
    </InputWrapper>
  );
};

export default NumberInputBox;
